import { defaultDateString } from "src/components/common/common";
import { BomDto } from "src/dtos/bom/BomDto";
import { ProductOrderDto } from "src/dtos/productOrder/ProductOrderDto";
import { ProductWorkDto } from "src/dtos/productWork/ProductWorkDto";
import { getFutureWeekdayExceptTodayAndTomorrow } from "src/utils/date/dateUtils";
import { formatDate, toLocalDateTime } from "src/utils/string/stringUtil";

export interface KSK2011_R01Dto extends ProductOrderDto {
    
    compNm: string;
    
    orderTypeNm: string;
    
    workplaceNm: string;
    
    jobTeamNm: string;
    
    itemNm: string;
    itemSpec: string;
    itemUnit: string;
    
    orderEmpNm: string;
    
    badQty: number;
    acceptQty: number;
    brandCd: string;
    brandNm: string;

	remark: string;

	workprocess: string;

	inserted: boolean,
	isModified: boolean,
	disabled: boolean,

    codeEntity?: any | null;
}

/**
 * 생산 실적 관리의 단일 기본 데이터 (신규 행 추가시 사용)
 */
export const defaultKSK2011_R01Dto: KSK2011_R01Dto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

    productOrderNo:  '',
    compCd: '',
    compNm: '',

    orderDt: formatDate(getFutureWeekdayExceptTodayAndTomorrow()),
    orderType: '',
    orderTypeNm: '',
    workplaceCd: '',
    workplaceNm: '',
    jobTeam: '',
    jobTeamNm: '',
    workProcess: '',
    itemCd: '',
    itemNm: '',
    itemSpec: '',
    itemUnit: '',
    orderQty: 0,
    orderEmp: '',
    orderEmpNm: '',
    productPlanNo: '',
    resultQty: 0,
    basOrderType: '',
    basOrderNo: '',
    basOrderItemNo: '',
    closeTag: "N",
    remark: '',

	workprocess: '',

	inserted: false,
	isModified: false,
	disabled: false,
	
    codeEntity: null,

    badQty: 0,
    acceptQty: 0,
    brandCd: '',
    brandNm: '',
};


export interface KSK2011_R01EditDto extends ProductWorkDto {
	
	itemCost: number;

	itemSpec: string;
	itemUnit: string;

	productResultNo: string;
	productDt: Date | undefined;
	
	beforeOrderQtySum: number;

	warehouseCd: string;
	warehouseNm: string;

	productQty: number;
	badQty: number;
	acceptQty: number;

	productOrderQtyView: number;

}

export const defaultKSK2011_R01EditDto: KSK2011_R01EditDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	
	productWorkNo: '',
	productWorkNm: '',
	compCd: '',
	compNm: '',
	workDt: formatDate(new Date()),
	fromTime: toLocalDateTime(new Date(defaultDateString)), 
	toTime: toLocalDateTime(new Date(defaultDateString)),
	orderType: '',
	workplaceCd: '',
	workplaceNm: '',
	jobTeam: '',
	workProcess: '',
	itemCd: '',
	itemNm: '',
	orderQty: 0,
	workEmp: '',
	workEmpNm: '',
	resultQty: 0,
	productOrderNo: '',
	closeTag: "N",
	remark: '',

	itemSpec: '',
	itemUnit: '',
	itemCost: 0,

	productResultNo: '',
	productDt: new Date(),

	beforeOrderQtySum: 0,

	warehouseCd: '',
	warehouseNm: '',
	
	productQty: 0,
	badQty: 0,
	acceptQty: 0,

    productOrderQtyView: 0,

	inserted: false,
	isModified: false
}


export interface KSK2011_R01DetailDto extends BomDto {
	productWarehouseQty: number;	//재공창고 보관수량
	materialWarehouseQty: number;	//자재창고 보관수량
	shortageQty: number;			//부족량
	totalOrderQty: number;			//생산에 필요한 총 자재 수량(총소요량)


}

export const defaultKSK2011_R01DetailDto: KSK2011_R01DetailDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	
	prntItemcd: '',
	prntItemnm: '',
	childItemcd: '',
	childItemnm: '',
	itemSpec: '',
	bomSeq: 0,
	bomUseyn: '',
	bomUpdateNo: '',
	prntItemQty: 0,
	prntItemUnit: '',
	childItemUsage: 0,
	childItemUnit: '',
	fixLossqty: 0,
	materialIntype: 'PURCHASE',
	lossPercent: 0,
	remark: '',

	productWarehouseQty: 0,
	materialWarehouseQty: 0,
	shortageQty: 0,
	totalOrderQty: 0,

	inserted: false,
	isModified: false,
}